import React from "react";
import PropTypes from "prop-types";
import styles from "./UserAvatar.module.scss";
import { UserAvatarSmallIcon } from "../../icons/UserAvatarSmallIcon";

export const UserAvatar = ({
  image,
  name,
  label,
  size,
  disabled = false,
  useAvatarIcon,
  className,
  labelClass,
  dataTestId,
  labelTestId,
}) => (
  <div
    className={`d-flex align-items-center ${styles.UserAvatar} ${disabled ? styles.Disabled : ""} ${
      size ? styles[size] : ""
    } ${className}`}
    data-testid={dataTestId}
  >
    {image ? (
      <img className={`${styles.Image}`} src={image} alt="UserPhoto" />
    ) : (
      <div className={`${styles.Image} ${styles.AvatarPlaceholder}`}>
        {useAvatarIcon || !(name && name[0]) ? (
          <UserAvatarSmallIcon width={18} height={18} />
        ) : (
          <div className={styles.Letter}>{name && name[0]}</div>
        )}
      </div>
    )}
    {label ? (
      <span className={`${styles.Label} ml-3 ${labelClass}`} data-testid={labelTestId}>
        {label}
      </span>
    ) : null}
  </div>
);

UserAvatar.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.any,
  size: PropTypes.string,
  useAvatarIcon: PropTypes.bool,
  className: PropTypes.string,
  labelClass: PropTypes.string,
  dataTestId: PropTypes.string,
};

UserAvatar.defaultProps = {
  dataTestId: "UserAvatar",
  labelTestId: "UserAvatarName",
};
export default UserAvatar;
